/* ============
 * Project Transformer
 * ============
 *
 * The transformer for the project.
 */

import Transformer from './transformer';

export default class ClientTransformer extends Transformer {

  static fetch(project) {
    return {
      id: project.id,
      organizationId: project.organization_id,
      name: project.name,
      description: project.description,
    };
  }

  static send(project) {
    return {
      id: project.id,
      organization_id: project.organizationId,
      name: project.name,
      description: project.description,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/project.js